module.exports = __webpack_public_path__ + "img/arrow-left.dca9b0f3.svg";